/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { GTMProvider } from '@eriksdigital/gs-ga4';

// Use consistent styling
import 'sanitize.css/sanitize.css';

// Import root app
import App from 'app';

import { HelmetProvider } from 'react-helmet-async';

import { configureAppStore } from 'store/configureStore';
import { ThemeProvider } from 'styled-components';
import { theme } from 'utils/theme';

import reportWebVitals from 'reportWebVitals';

import GlobalStyle from 'styles/global-styles';

export const store = configureAppStore({}, null);
const MOUNT_NODE = document.getElementById('root') as HTMLElement;

const consoleError = console.error.bind(console);
console.error = (message, ...args) => {
  if (message.code === 'MISSING_TRANSLATION') {
    return;
  }
  consoleError(message, ...args);
};

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <HelmetProvider>
      <GTMProvider env={process.env.REACT_APP_ENVIRONMENT}>
        <Provider store={store}>
          <React.StrictMode>
            <App />
            <GlobalStyle />
          </React.StrictMode>
        </Provider>
      </GTMProvider>
    </HelmetProvider>
  </ThemeProvider>,
  MOUNT_NODE,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
